import { QRCode } from 'react-qrcode-logo';
import logoImage from '@client/images/logo.svg';
import { Modal, ModalProps } from '@client/new/components/Modal/Modal';

type IosAppQrCodeModalModalProps = Pick<ModalProps, 'isOpen' | 'onClose'>;

const iosAppLink =
  'https://apps.apple.com/us/app/playbook-creator/id1166632935';

export const IOSAppQrCodeModal = (props: IosAppQrCodeModalModalProps) => (
  <Modal
    {...props}
    title="Download Creator App"
    sx={{ maxWidth: 600, height: 500 }}
    hideClose
    centerTitle
  >
    <div className="flex flex-col items-center gap-4 text-center">
      <p className="font-semibold text-lg">
        Scan this QR code to visit App Store
        <br />
        and download <b>Playbook Creator App</b>
      </p>
      <QRCode
        value={iosAppLink}
        ecLevel="H"
        size={240}
        fgColor="#000"
        quietZone={20}
        logoImage={logoImage}
        logoPadding={10}
        removeQrCodeBehindLogo={true}
        qrStyle="squares"
        eyeRadius={4}
      />
    </div>
  </Modal>
);
